import { React } from '../../shared/react.js';
import { Icon } from '../../shared/icons.js';
import { useAppRuntime, useAppState } from '../../app/app.context.js';

export function SavedCollections(props: { readonly sectionRef?: { current: HTMLElement | null } }) {
  const runtime = useAppRuntime();
  const state = useAppState();

  return (
    <section ref={props.sectionRef} className="saved-collections" aria-labelledby="saved-collections-title">
      <div className="saved-collections__heading">
        <h2 id="saved-collections-title">Saved collections</h2>
      </div>
      <div className="saved-collections__list">
        {state.savedCollections.slice(0, 4).map((collection) => (
          <button
            type="button"
            key={collection.id}
            className={state.scopedCollectionId === collection.id ? 'is-active' : ''}
            onClick={() => void runtime.scopeCollection(state.scopedCollectionId === collection.id ? null : collection.id)}
          >
            <span className="saved-collection__swatch" style={{ backgroundColor: collection.color }}/>
            <span>{collection.name}</span>
            <small>{collection.artworkIds.length}</small>
          </button>
        ))}
        {state.savedCollections.length === 0 && <p>Save a result neighborhood to keep it close.</p>}
      </div>
      <button className="saved-collections__new" type="button" onClick={() => void runtime.saveCurrentCollection()} disabled={!state.approximate}>
        <Icon name="plus" size={13}/><span>New collection</span>
      </button>
    </section>
  );
}
